import React, { useState } from "react";

export default function SelectQty(props) {
  // PROPS COMING FROM ProductScreenNew & ProductLanding & ProductDetailsPop
  const { product, qtyAlert, setQtyAlert, setQty, qty, type } = props;

  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const increment = () => {
    if (qty >= 0) {
      setQty((prevQty) => prevQty + 1);
      setIsButtonClicked(true);
    }
  };

  const decrement = () => {
    if (qty > 1) {
      setQty((prevQty) => prevQty - 1);
      setIsButtonClicked(true);
    }
  };

  return (
    <>
      {Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
        (a, c) => a + c,
        0
      ) > 0 ? (
        <>
          <div className="row-center-webkit w90p">
            <div className="row whitebck h2r beddo-border-bottom">
              {type === "inputNumber" ? (
                <div className="row-space w100p">
                  {!isButtonClicked ? (
                    <input
                      className="w30p"
                      type="number"
                      autoComplete="off"
                      inputMode="numeric"
                      step="1"
                      min="1"
                      max="10000"
                      value={qty === 0 ? "" : qty} // If value attribute is not introduced, react shoots "Uncontrolled input to controlled..." error
                      placeholder="Adet giriniz"
                      style={{
                        border: "none",
                        fontSize: "16px",
                        width: "100%",
                      }}
                      onChange={(e) => {
                        setQtyAlert("");
                        setQty(Number(e.target.value));
                      }}
                      onBlur={() => setIsButtonClicked(false)}
                    />
                  ) : (
                    <input
                      className="w30p"
                      type="number"
                      autoComplete="off"
                      inputMode="numeric"
                      step="1"
                      min="1"
                      max="10000"
                      value={isButtonClicked ? qty : ""}
                      placeholder="Adet giriniz"
                      style={{
                        border: "none",
                        fontSize: "16px",
                        width: "100%",
                      }}
                      onChange={(e) => {
                        setQtyAlert("");
                        setQty(Number(e.target.value));
                      }}
                    />
                  )}

                  <div className="txtright w40p">
                    <button
                      type="button"
                      className="secondary-free w2-5r h1-75r marginright0-25r"
                      onClick={increment}
                    >
                      <i className="fas fa-plus white"></i>
                    </button>
                    <button
                      type="button"
                      className="secondary-free w2-5r h1-75r"
                      onClick={decrement}
                    >
                      <i className="fas fa-minus white"></i>
                    </button>
                  </div>
                </div>
              ) : (
                <select
                  style={{
                    border: "none",
                    fontSize: "16px",
                    width: "100%",
                    color: "grey",
                  }}
                  onChange={(e) => {
                    setQtyAlert("");
                    setQty(e.target.value);
                  }}
                >
                  {[...Array(product.defaultMaxPurchaseQty).keys()].map((q) => {
                    return (
                      <option key={q} value={q} className="iphone-fs">
                        {q === 0
                          ? "Adet Seçiniz"
                          : `${q} ${
                              product.productUnit ? product.productUnit : "Adet"
                            }`}
                      </option>
                    );
                  })}
                </select>
              )}
            </div>
          </div>
          {qtyAlert && (
            <p className="fs1 red-col txtcenter rad2-5r margintop-25 padq lighterredbck">
              {qtyAlert}
            </p>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
}
